import React from 'react';
import { mapContentToBlock } from '../util/mapContentToBlock.tsx';
export const ContentArea = ({ contentArea }) => {
    if (!contentArea) {
        return null;
    }
    return (React.createElement(React.Fragment, null, contentArea.expandedValue?.map((block, index) => (React.createElement(React.Fragment, { key: index }, mapContentToBlock(block))))));
};
